import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross Blue Shield of Oklahoma",
  shortName: "BCBSOK",
  slug: "bcbsok-insurance",
  seoTitle:
    "Blue Cross Blue Shield of Oklahoma (BCBSOK) TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross Blue Shield of Oklahoma (BCBSOK) policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBSOK TMS coverage, Blue Cross Blue Shield Oklahoma SPRAVATO authorization, BCBSOK mental health benefits Coral Springs FL, BCBSOK depression treatment Florida",
};

export const BcbsokInsurance = () => <InsurancePageTemplate config={config} />;
export default BcbsokInsurance;
